import { action, computed, observable } from 'mobx';

import { fetchRecommendedItems } from '~api/GoogleRecommendedAPI/GoogleRecommendedAPI';
import { parseRecommendedProductIds } from '~api/GoogleRecommendedAPI/utils';

export default class RecommendedItemsRepository {
    @observable private _items: string[] = [];
    @observable private _isLoading: boolean = false;

    @action public getRecommendedItems = () => {
        return !this._items?.length ? this.fetchRecommendedData() : this._items;
    };

    @action public fetchRecommendedData = async () => {
        this._isLoading = true;

        return fetchRecommendedItems()
            .then((recommendedItems) => {
                if (recommendedItems !== null) {
                    const productIds = parseRecommendedProductIds(recommendedItems);
                    this._items = productIds;

                    return productIds;
                } else {
                    throw new Error('No Recommended Products Found');
                }
            })
            .finally(() => (this._isLoading = false));
    };

    @computed public get isLoading() {
        return this._isLoading;
    }
}
